import React, { useState } from "react";
import { Plus } from "lucide-react";
import "../sass/landing/faq.scss";

const CONTACT_EMAIL = "contato@psyassist.com.br";
const FAQS = [
  { category: "Uso", question: "O PsyAssist funciona no computador e no celular?", answer: "Sim. O PsyAssist funciona pelo navegador e se adapta a computador, tablet e celular. Você pode acompanhar sua rotina sem precisar instalar um programa específico." },
  { category: "Teste", question: "Como funcionam os 7 dias grátis?", answer: "Você escolhe um plano, faz o cadastro e usa o PsyAssist por 7 dias. O cartão é solicitado no cadastro, mas a cobrança começa somente após o período de teste." },
  { category: "Assinatura", question: "Existe fidelidade?", answer: "Não. A assinatura é mensal. Você não precisa assumir um contrato de permanência para começar a usar o PsyAssist." },
  { category: "Planos", question: "Qual é a diferença entre o Essencial e o Premium?", answer: "No Essencial, você centraliza pacientes, agenda, prontuários, sessões e financeiro. No Premium, além dessa organização, o PsyAssist passa a automatizar partes da rotina, como lembretes, confirmações, cobranças, comunicações e integrações com Google Agenda e Google Meet." },
  { category: "WhatsApp", question: "O PsyAssist envia lembretes e confirmações pelo WhatsApp?", answer: "Sim, no Premium. O sistema pode enviar comunicações pelo WhatsApp e por e-mail, incluindo lembretes de sessão e confirmações. O histórico dessas comunicações fica disponível na Central de Comunicações." },
  { category: "Cobranças", question: "Como funciona a cobrança automática?", answer: "No Premium, você configura uma régua com os momentos em que deseja lembrar uma pendência. A partir daí, o PsyAssist acompanha essas etapas e pode enviar as comunicações automaticamente, reduzindo a necessidade de você cobrar cada paciente manualmente." },
  { category: "Cobranças", question: "O PsyAssist recebe o dinheiro dos meus pacientes?", answer: "Não. O PsyAssist ajuda a organizar e acompanhar cobranças, mas o pagamento continua sendo feito diretamente para você. Se houver uma chave Pix cadastrada, ela pode ser incluída na comunicação enviada ao paciente." },
  { category: "Google", question: "Posso usar Google Agenda e Google Meet?", answer: "Sim, no Premium. Você pode conectar sua conta Google para sincronizar os atendimentos com o Google Agenda e utilizar links do Google Meet nas sessões online." },
  { category: "Prontuário", question: "Consigo manter anamnese, prontuário e evoluções no mesmo lugar?", answer: "Sim. Cada paciente possui um histórico próprio, com anamnese, prontuário, evoluções e informações dos atendimentos organizados no mesmo contexto." },
  { category: "PSYA", question: "O que é a PSYA?", answer: "A PSYA é a assistente do PsyAssist, disponível no Premium. Ela utiliza o contexto registrado por você no sistema para organizar informações e gerar sugestões que podem apoiar sua análise, sempre sob revisão do psicólogo." },
  { category: "PSYA", question: "A PSYA faz diagnóstico ou recomenda tratamento?", answer: "Não. A PSYA organiza informações e faz sugestões, mas não substitui a avaliação clínica. Avaliações, diagnósticos e condutas continuam sendo do profissional." },
  { category: "Migração", question: "Já uso outra ferramenta. Consigo trazer meus dados?", answer: "Depende de como os dados estão armazenados na ferramenta atual. Como o PsyAssist é acompanhado diretamente pela equipe que desenvolve o produto, podemos avaliar seu caso e orientar a melhor forma de começar." },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="lp-faq" aria-labelledby="faq-title">
      <div className="lp-shell lp-faq__grid">
        <header className="lp-faq__side">
          <p className="lp-faq__eyebrow">Perguntas frequentes</p>
          <h2 id="faq-title">Antes de começar.</h2>
          <p className="lp-faq__lead">
            O que psicólogos costumam perguntar sobre o teste, os planos e o funcionamento.
          </p>
          <div className="lp-faq__contact">
            <p>
              Sua dúvida não está aqui? Ela chega direto a quem desenvolve o
              PsyAssist. Pode ser sobre sua rotina, uma necessidade específica
              ou uma ideia para o produto.
            </p>
            <a className="lp-link" href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Dúvida sobre o PsyAssist Pro")}`}>
              {CONTACT_EMAIL}
            </a>
          </div>
        </header>

        <div className="lp-faq__list">
          {FAQS.map((item, index) => {
            const open = openIndex === index;
            return (
              <div className={`lp-faq__item ${open ? "is-open" : ""}`} key={item.question}>
                <h3>
                  <button
                    type="button"
                    id={`faq-question-${index}`}
                    aria-expanded={open}
                    aria-controls={`faq-answer-${index}`}
                    onClick={() => setOpenIndex(open ? -1 : index)}
                  >
                    <span className="lp-faq__question">{item.question}</span>
                    <Plus className="lp-faq__icon" size={20} aria-hidden="true" />
                  </button>
                </h3>
                <div
                  id={`faq-answer-${index}`}
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                  className="lp-faq__answer"
                  hidden={!open}
                >
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
